var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBikePackageIcon = function SvgBikePackageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#757D86",
    d: "m27.96 8.268-11-6.018a1.99 1.99 0 0 0-1.92 0l-11 6.02A2 2 0 0 0 3 10.02v11.956a2 2 0 0 0 1.04 1.75l11 6.021a1.99 1.99 0 0 0 1.92 0l11-6.021a2 2 0 0 0 1.04-1.75V10.022a2 2 0 0 0-1.04-1.754M16 4l10.043 5.5-3.722 2.037-10.044-5.5zm0 11L5.958 9.5l4.237-2.32 10.043 5.5zM5 11.25l10 5.472v10.724L5 21.977zm22 10.722-10 5.474V16.727l4-2.189V19a1 1 0 1 0 2 0v-5.557l4-2.193v10.722"
  })));
};
export default SvgBikePackageIcon;